<template>
<div>
  <v-app id="inspire">
      <v-data-table
    :headers="headers"
    :items="desserts"

    :sort-desc="true"

    class="elevation-1"
    :search="search"
  >
    <template v-slot:top>
      <v-toolbar flat color="white">

        <v-toolbar-title class="hidden-sm-and-down">
         <v-chip
            class="ma-4"
            color="primary"
            outlined
            pill
          >
            Logs de Usuários
            <v-icon right>person</v-icon>
          </v-chip>

        </v-toolbar-title>

        <v-divider class="mx-8  hidden-sm-and-down" inset vertical></v-divider>

         <v-divider class="mx-8  hidden-sm-and-down" inset vertical></v-divider>

        <!--  search  -->

        <div class="flex-grow-1"></div>

        <v-text-field
          v-model="search"
          append-icon="search"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
        <!-- end  search  -->

        <v-divider class="mx-4 hidden-sm-and-down" inset vertical></v-divider>
 <v-btn  text icon color="green">
              <v-icon>cached</v-icon>
            </v-btn>

        <v-spacer></v-spacer>
      </v-toolbar>
    </template>
    <template v-slot:no-data>
      no data
    </template>
  </v-data-table>

  </v-app>

    </div>

</template>

<script>
export default {
  data: () => ({
    desserts: [],
    headers: [
      {
        text: 'Usuário',
        align: 'left',
        sortable: false,
        value: 'user'
      },

      { text: 'Descrição.', value: 'idPessoa' },
      { text: 'Módulo', value: 'role_descricao' },
      { text: 'Acção', value: 'username' },

      { text: 'Cadastrado em', value: 'ver_status', sortable: false }
    ],
    search: '',
    dateNow: new Date().toISOString().substr(0, 10),
    valid: true,
    data: {
      'pkperiodo': 0,
      'periodoextensao': ''
    },
    periodo: [
      {
        'pkperiodo': 1,
        'periodoextensao': 'Hoje'
      },
      {
        'pkperiodo': 2,
        'periodoextensao': 'Esta semana'
      },
      {
        'pkperiodo': 3,
        'periodoextensao': 'Este mês'
      },
      {
        'pkperiodo': 4,
        'periodoextensao': 'Últimos 30 dias'
      },
      {
        'pkperiodo': 5,
        'periodoextensao': 'Escolha o período'
      }
    ]
  }),
  methods: {

    chosenperiod (time) {
      switch (time.pkperiodo) {
        case 1:
          return this.dateNow
        case 2:
          return this.dateNow
        default:
          break
      }
      console.log('Data: ' + this.dateNow)
    }
  }
}
</script>
